import request from '@/utils/request'

export function register(data) {
  return request({
    url: '/auth/register',
    method: 'post',
    data
  })
}

export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

export function emailLogin(data) {
  return request({
    url: '/auth/emailLogin',
    method: 'post',
    data
  })
}

export function phoneLogin(data) {
  return request({
    url: '/auth/phoneLogin',
    method: 'post',
    data
  })
}

export function sendEmailCode(data) {
  return request({
    url: '/auth/sendEmailCode',
    method: 'post',
    data,
    timeout: 60000 // 邮箱验证码发送设置为60秒超时，因为邮件服务器响应可能较慢
  })
}

export function sendSmsCode(data) {
  return request({
    url: '/auth/sendSmsCode',
    method: 'post',
    data
  })
}

export function checkEmail(email) {
  return request({
    url: '/auth/checkEmail',
    method: 'get',
    params: { email }
  })
}

export function checkPhone(phone) {
  return request({
    url: '/auth/checkPhone',
    method: 'get',
    params: { phone }
  })
}

export function forgotPassword(data) {
  return request({
    url: '/auth/forgotPassword',
    method: 'post',
    data
  })
}

export function generateCaptcha() {
  return request({
    url: '/auth/generateCaptcha',
    method: 'get'
  })
}

